import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { RESUBSCRIBE_API_PREFIX } from '../api/unsubscribe-api'

// TODO: move to tanstack
interface UseResubscribeResult {
  resubscribeToMarketingEmails: (slug: string, messageId: string) => Promise<void>
  resubscribeToAutomationRule: (recipientEmailAddress: string, id: string) => Promise<void>
  resubscribeToMarketingEmailsCampaign: (
    slug: string,
    messageId: string,
    campaignId: string,
  ) => Promise<void>
  resubscribeToTransactionalEmail: (slug: string) => Promise<void>
  isFetching: boolean
}

export const useResubscribe = (): UseResubscribeResult => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.post,
  })
  return {
    resubscribeToMarketingEmails: async (slug: string, messageId: string) => {
      await fetcher(`${RESUBSCRIBE_API_PREFIX}/resubscribe-page/${slug}/${messageId}`)
    },

    resubscribeToAutomationRule: async (recipientEmailAddress: string, id: string) => {
      await fetcher(
        `${RESUBSCRIBE_API_PREFIX}/resubscribe-to-automation-rule/${recipientEmailAddress}/${id}`,
      )
    },

    resubscribeToMarketingEmailsCampaign: async (
      slug: string,
      messageId: string,
      campaignId: string,
    ) => {
      await fetcher(
        `${RESUBSCRIBE_API_PREFIX}/resubscribe-page/${slug}/${messageId}/campaign/${campaignId}`,
      )
    },

    resubscribeToTransactionalEmail: async (slug: string) => {
      await fetcher(`${RESUBSCRIBE_API_PREFIX}/resubscribe-to-transactional-emails/${slug}`)
    },

    isFetching: isFetching,
  }
}
